import React from 'react';
import { Typography } from '@mui/material';

import { finishInsertTrussGroup } from '../../../../store/actions/trussGroups';
import { getPickingObjectInfo } from '../../../../store/selectors/pickingSelectors';
import { updateInsertingTrussGroup } from '../../../../store/slices/applicationSlice';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { getUpdatedTrussEnvelopeGuidsForTrussGroup, TrussGroupProperties } from '../TrussGroupProperties';
import InsertionPanelContainer from './InsertionPanelContainer';

export function TrussGroupInsertionPanel() {
  const dispatch = useAppDispatch();

  const trussGroupInsertingInfo = useAppSelector((state) => state.application.insertingObjectInfo);
  const trussGroups = useAppSelector((state) => state.trussGroups);
  const pickingObjectInfo = useAppSelector(getPickingObjectInfo);
  const isPickingTrussEnvelopes = pickingObjectInfo?.type === 'pickingTrussEnvelopesForTrussGroup';

  if (trussGroupInsertingInfo?.type !== 'trussGroup') return null;

  const disabled = trussGroupInsertingInfo.data.name === '';
  return (
    <InsertionPanelContainer
      disabled={disabled}
      onInsert={() => {
        if (!disabled) {
          dispatch(
            finishInsertTrussGroup(
              isPickingTrussEnvelopes
                ? {
                    ...trussGroupInsertingInfo.data,
                    trussEnvelopeGuids: getUpdatedTrussEnvelopeGuidsForTrussGroup(
                      trussGroupInsertingInfo.data.trussEnvelopeGuids,
                      pickingObjectInfo.trussEnvelopeGuidsToAdd,
                      pickingObjectInfo.trussEnvelopeGuidsToRemove,
                    ),
                  }
                : trussGroupInsertingInfo.data,
            ),
          );
        }
      }}
    >
      <Typography align="center" variant="h5" sx={{ marginBottom: 3 }}>
        Insert Truss Group
      </Typography>

      <TrussGroupProperties
        trussGroup={trussGroupInsertingInfo.data}
        onChange={(updatedTrussGroup) => void dispatch(updateInsertingTrussGroup(updatedTrussGroup))}
        otherTrussGroups={trussGroups}
        inserting
      />
    </InsertionPanelContainer>
  );
}
